<template>
  <h1>商圈</h1>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/service/business/index.vue